export default "__VITE_ASSET__CKrdSFWV__"